module.exports = __webpack_public_path__ + "static/waves_green-67a53bd9125a2c87657051177a14de2c.jpg";